module.exports = __webpack_public_path__ + "static/media/hibiki.8069afb9.svg";